<ng-content>
  <pbir-visual-shell></pbir-visual-shell>
  @if (contentError()) {
    <div class="content-error-wrapper">
      <pbir-visual-content-error-display [error]="contentError()"></pbir-visual-content-error-display>
    </div>
  }
</ng-content>